import { useTrackingAvDistributionType, useTrackingEventsDatas, } from "./useTracking";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingLeadInterestPhone = (av_zone) => {
    const distributionType = useTrackingAvDistributionType();
    const EVENT_DATA = {
        event: distributionType === "1"
            ? "lead_classified_phone_display_rent"
            : "lead_classified_phone_display_buy",
        av_zone,
        ...useTrackingEventsDatas({
            displayMedium: true,
            conversionType: "phone",
        }),
    };
    return useTrackingEvent(EVENT_DATA);
};
